import { PrognoseStatus, PrognoseStatusOptions } from "@/entities/dossier-details";
import { PrognoseDto } from "@/shared/types";
import { parseISO } from "date-fns";

export type Prognose = {
    status: string;
    datumTijd: Date;
    gewijzigdDatumTijd?: Date;
    toelichting?: string;
};

export const Prognose = {
    statusDefaultValue: (status: string | undefined): PrognoseStatus => {
        if (status && Prognose.isPrognoseStatus(status)) return status;
        return status ? PrognoseStatusOptions.Aangepast : PrognoseStatusOptions.Initieel;
    },
    isPrognoseStatus: (value: unknown): value is PrognoseStatus => Object.values(PrognoseStatusOptions).includes(value as PrognoseStatus),
    fromDto: (dto: PrognoseDto): Prognose => ({
        status: dto.status,
        datumTijd: parseISO(dto.datumTijd),
        gewijzigdDatumTijd: dto.gewijzigdDatumTijd ? parseISO(dto.gewijzigdDatumTijd) : undefined,
        toelichting: dto.toelichting,
    }),
    toDto: (prognose: Prognose): PrognoseDto => ({
        status: prognose.status,
        datumTijd: prognose.datumTijd.toISOString(),
        gewijzigdDatumTijd: prognose?.gewijzigdDatumTijd?.toISOString() ?? "",
        toelichting: prognose.toelichting,
    }),
};
